/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Dialog_DescInputs */

const vi_grower_area_camera_dialog_desc = /** @type {(inputs: Grower_Area_Camera_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy token của từng camera trong tài liệu bàn giao của đơn vị vận hành camera.`)
};

/**

* @param {Grower_Area_Camera_Dialog_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_dialog_desc = /** @type {((inputs?: Grower_Area_Camera_Dialog_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Dialog_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_dialog_desc(inputs)
});